import { memo as n, useMemo as a } from "react";
import { Shape as p } from "three";
import { jsx as m } from "react/jsx-runtime";
const l = n(function({
  points: t,
  extrude: s,
  ...h
}) {
  const i = a(() => {
    const o = new p();
    for (let r = 0; r < t.length; r++) {
      let e = t[r];
      "isVector2" in e && (e = [e.x, e.y]), r === 0 ? o.moveTo(e[0], e[1]) : o.lineTo(e[0], e[1]);
    }
    return o.closePath(), o;
  }, [t]);
  return /* @__PURE__ */ m("mesh", {
    ...h,
    children: /* @__PURE__ */ m("extrudeGeometry", {
      args: [i, s]
    })
  });
});
l.displayName = "Shape";
export {
  l as Extrude
};
//# sourceMappingURL=index.js.map
